export enum JobStatus {
    Started = 'Started',
    Completed = 'Completed',
    Running = 'Running',
    NoJob = 'NoJob',
    Failed = 'Failed',
}